export default __webpack_public_path__ + "static/media/afterparty-hero-event.848dc6d3.jpg";